import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub5_1/31c88223833075ed30512f582928a4a7_water__c1_w280_h397.jpg'


const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/expert/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'Profesional',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "전문가교육",
          subtitle: "전문가교육",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _createVNode(BoardNavbar),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "sub_subject" }, "전문가 과정", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                _createElementVNode("ul", { class: "line line4" }, [
                  _createElementVNode("li", null, "성장 – 폴리오 전문가 과정"),
                  _createElementVNode("li", null, [
                    _createElementVNode("dl", { class: "line2" }, [
                      _createElementVNode("dt", null, "제목"),
                      _createElementVNode("dd", null, "성장 – 폴리오_전문가 과정")
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("figure", null, [
                      _createVNode(_component_n_space, { justify: "center" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[1] || (_cache[1] = _createStaticVNode("<li data-v-96ef687c><dl data-v-96ef687c><dt data-v-96ef687c>목적</dt><dd data-v-96ef687c> &quot;성장–폴리오_전문가 과정&quot;은 교사를 비롯한 상담전문가 등을 대상으로, 중고등학생 및 대학생의 진로 선택, 진학, 취업 등을 안내, 코칭할 수 있는 전문성 함양을 목적으로 한다. </dd></dl><dl data-v-96ef687c><dt data-v-96ef687c>목표</dt><dd data-v-96ef687c> 목표 1. 참여자는 21세기 핵심 역량인 창의역량, 재능, 경험 등에 관한 학문적 배경을 탐색한다. <br data-v-96ef687c> 목표 2. 중고등학생 및 대학생의 진로, 선발 및 진학, 전공 및 직업군, 취업 등과 관련된 평가 방법을 탐색한다. <br data-v-96ef687c> 목표 3. 참여자는 핵심 역량 기반의 &#39;성장모델&#39;의 개념모델을 탐색한다.<br data-v-96ef687c> 목표 4. &#39;교육_성장-폴리오&#39; 과정의 내용 구성 및 운영에 관하여 이해하고, 이를 기반으로 &#39;MY 성장모델&#39;을 시뮬레이션 한다. <br data-v-96ef687c> 목표 5. 모든 참가자가 &#39;MY 성장시스템&#39;을 발표한다. 이때 또래 평가를 진행한다.<br data-v-96ef687c></dd></dl><dl data-v-96ef687c><dt data-v-96ef687c>대상</dt><dd data-v-96ef687c>교과 교사, 진로 교사, 상담 교사, 상담 전문가 등<br data-v-96ef687c></dd></dl><dl class=\"line2\" data-v-96ef687c><dt data-v-96ef687c>구분·시수</dt><dd data-v-96ef687c>15시간</dd></dl></li>", 1))
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div data-v-96ef687c><ul class=\"line line4\" data-v-96ef687c><li data-v-96ef687c> 결과물<br data-v-96ef687c> • &#39;교육_성장-폴리오&#39; 과정 운영 계획서<br data-v-96ef687c> • &#39;MY 성장모델&#39; </li><li data-v-96ef687c><dl class=\"line2\" data-v-96ef687c><dt data-v-96ef687c>구성</dt><dd data-v-96ef687c> • 모듈 1. (1) 개회식 및 프로그램 소개, (2) 21세기 핵심 역량에 대한 학문적 배경의 탐색 <br data-v-96ef687c> • 모듈 2. 진로, 선발 및 진학, 전공 및 직업군, 취업 등과 관련된 평가 방법의 탐색 <br data-v-96ef687c> • 모듈 3. 역량모델링 및 &#39;성장모델&#39;의 개념모델의 탐색<br data-v-96ef687c> • 모듈 4. (1)&#39;교육_성장-폴리오&#39; 과정의 내용 구성 및 운영에 대한 이해, (2)&#39;MY 성장모델&#39;의 시뮬레이션<br data-v-96ef687c> • 모듈 5. &#39;MY 성장시스템&#39;의 발표 및 평가 </dd></dl></li></ul></div><div data-v-96ef687c><ul class=\"line box22\" data-v-96ef687c><li data-v-96ef687c> 강의<br data-v-96ef687c> 강의 진행자 <br data-v-96ef687c><br data-v-96ef687c> • 선발 및 진학 전문가<br data-v-96ef687c> • &#39;성장–폴리오 전문가 과정&#39; 수료자 </li><li data-v-96ef687c><dl class=\"line2\" data-v-96ef687c><dt data-v-96ef687c>이수혜택</dt><dd data-v-96ef687c> • &#39;Activity_성장-폴리오_학생 과정&#39; 운영 자격 부여<br data-v-96ef687c> • &#39;교육_성장-폴리오_전문가 과정&#39; 강의 자격 부여 </dd></dl></li></ul></div>", 2)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Product.Expert.Expert.Path}`
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("목록")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})